import { useShowFilterState } from 'search/hooks/useShowFilterState';

export const useVisibleFilters = (filters) => {
  const showHideFiltersState = useShowFilterState();

  const filterVisibilityMap = {
    brandsList: showHideFiltersState.showBrandFilter && filters?.brandsList?.length > 0,
    productCategoriesList:
      showHideFiltersState.showCategoryFilter && filters?.productCategoriesList?.length > 0,
    gendersList: showHideFiltersState.showGenderFilter && filters?.gendersList?.length > 0,
    sizesList: showHideFiltersState.showSizeFilter && filters?.sizesList?.length > 0,
    productConditionsList:
      showHideFiltersState.showConditionFilter && filters?.productConditionsList?.length > 0,
    colorsList: showHideFiltersState.showColorFilter && filters?.colorsList?.length > 0,
    price: showHideFiltersState.showPriceFilter,
    instantShip: showHideFiltersState.showInstantFilter,
    underRetail: showHideFiltersState.showDiscountTagFilter,
    inStock: showHideFiltersState.showAvailableNowFilter,
    yearsList: showHideFiltersState.showYearFilter && filters?.yearsList?.length > 0,
  };

  return filterVisibilityMap;
};
